export const DashboardIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_107_1941"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_1941)">
        <path
          d="M4.92345 17.0832C4.50915 17.0832 4.15449 16.9357 3.85949 16.6407C3.56449 16.3457 3.41699 15.991 3.41699 15.5767V4.42296C3.41699 4.00866 3.56449 3.654 3.85949 3.359C4.15449 3.064 4.50915 2.9165 4.92345 2.9165H8.36887C8.78317 2.9165 9.13783 3.064 9.43283 3.359C9.72783 3.654 9.87533 4.00866 9.87533 4.42296V15.5767C9.87533 15.991 9.72783 16.3457 9.43283 16.6407C9.13783 16.9357 8.78317 17.0832 8.36887 17.0832H4.92345ZM12.6318 17.0832C12.2175 17.0832 11.8628 16.9357 11.5678 16.6407C11.2728 16.3457 11.1253 15.991 11.1253 15.5767V11.5063C11.1253 11.092 11.2728 10.7373 11.5678 10.4423C11.8628 10.1473 12.2175 9.99984 12.6318 9.99984H16.0772C16.4915 9.99984 16.8462 10.1473 17.1412 10.4423C17.4362 10.7373 17.5837 11.092 17.5837 11.5063V15.5767C17.5837 15.991 17.4362 16.3457 17.1412 16.6407C16.8462 16.9357 16.4915 17.0832 16.0772 17.0832H12.6318ZM12.6318 8.74984C12.2175 8.74984 11.8628 8.60234 11.5678 8.30734C11.2728 8.01234 11.1253 7.65768 11.1253 7.24338V4.42296C11.1253 4.00866 11.2728 3.654 11.5678 3.359C11.8628 3.064 12.2175 2.9165 12.6318 2.9165H16.0772C16.4915 2.9165 16.8462 3.064 17.1412 3.359C17.4362 3.654 17.5837 4.00866 17.5837 4.42296V7.24338C17.5837 7.65768 17.4362 8.01234 17.1412 8.30734C16.8462 8.60234 16.4915 8.74984 16.0772 8.74984H12.6318Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// ============================================================ContactsIcon(Enquiries)======================================================================================///
export const ContactsIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2509"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2509)">
        <path
          d="M10.4989 11.2499C11.1353 11.2499 11.6764 11.0272 12.1224 10.5818C12.5685 10.1363 12.7916 9.59551 12.7916 8.95926C12.7916 8.32288 12.5689 7.78169 12.1235 7.33572C11.678 6.88961 11.1372 6.66656 10.501 6.66656C9.86457 6.66656 9.32339 6.88926 8.87742 7.33468C8.43131 7.7801 8.20825 8.321 8.20825 8.95739C8.20825 9.59364 8.43096 10.1348 8.87638 10.5809C9.32179 11.0269 9.86263 11.2499 10.4989 11.2499ZM4.08971 16.2499C3.66874 16.2499 3.31242 16.1041 3.02075 15.8124C2.72909 15.5207 2.58325 15.1644 2.58325 14.7434V5.25635C2.58325 4.83538 2.72909 4.47906 3.02075 4.18739C3.31242 3.89572 3.66874 3.74989 4.08971 3.74989H16.9101C17.3311 3.74989 17.6874 3.89572 17.9791 4.18739C18.2708 4.47906 18.4166 4.83538 18.4166 5.25635V14.7434C18.4166 15.1644 18.2708 15.5207 17.9791 15.8124C17.6874 16.1041 17.3311 16.2499 16.9101 16.2499H4.08971ZM5.83659 14.9999H15.1633C14.5383 14.3289 13.8321 13.814 13.0447 13.4551C12.2573 13.0961 11.4091 12.9166 10.4999 12.9166C9.59075 12.9166 8.74249 13.0961 7.95513 13.4551C7.16777 13.814 6.46159 14.3289 5.83659 14.9999ZM4.66659 18.4934C4.4895 18.4934 4.3411 18.4335 4.22138 18.3136C4.10152 18.1938 4.04159 18.0453 4.04159 17.8682C4.04159 17.691 4.10152 17.5426 4.22138 17.423C4.3411 17.3033 4.4895 17.2434 4.66659 17.2434H16.3333C16.5103 17.2434 16.6587 17.3034 16.7785 17.4232C16.8983 17.5431 16.9583 17.6916 16.9583 17.8686C16.9583 18.0459 16.8983 18.1943 16.7785 18.3138C16.6587 18.4336 16.5103 18.4934 16.3333 18.4934H4.66659ZM4.66659 2.75635C4.4895 2.75635 4.3411 2.69642 4.22138 2.57656C4.10152 2.45669 4.04159 2.30822 4.04159 2.13114C4.04159 1.95392 4.10152 1.80551 4.22138 1.68593C4.3411 1.56621 4.4895 1.50635 4.66659 1.50635H16.3333C16.5103 1.50635 16.6587 1.56628 16.7785 1.68614C16.8983 1.806 16.9583 1.95447 16.9583 2.13156C16.9583 2.30878 16.8983 2.45718 16.7785 2.57676C16.6587 2.69649 16.5103 2.75635 16.3333 2.75635H4.66659Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================StudentsIcon(Students)======================================================================///
export const StudentsIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_107_1957"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_107_1957)">
        <path
          d="M5.51933 14.4102C6.22766 13.8847 6.99933 13.4696 7.83433 13.165C8.66919 12.8606 9.5578 12.7084 10.5002 12.7084C11.4425 12.7084 12.3311 12.8606 13.166 13.165C14.001 13.4696 14.7727 13.8847 15.481 14.4102C15.9991 13.8408 16.4095 13.1816 16.7125 12.4327C17.0154 11.6839 17.1668 10.873 17.1668 10C17.1668 8.15282 16.5175 6.5799 15.2189 5.28129C13.9203 3.98268 12.3474 3.33337 10.5002 3.33337C8.65294 3.33337 7.08002 3.98268 5.78141 5.28129C4.4828 6.5799 3.8335 8.15282 3.8335 10C3.8335 10.873 3.98495 11.6839 4.28787 12.4327C4.59079 13.1816 5.00127 13.8408 5.51933 14.4102ZM10.5002 10.625C9.73947 10.625 9.09794 10.3638 8.57558 9.84129C8.05308 9.31893 7.79183 8.6774 7.79183 7.91671C7.79183 7.15601 8.05308 6.51448 8.57558 5.99212C9.09794 5.46962 9.73947 5.20837 10.5002 5.20837C11.2609 5.20837 11.9024 5.46962 12.4247 5.99212C12.9472 6.51448 13.2085 7.15601 13.2085 7.91671C13.2085 8.6774 12.9472 9.31893 12.4247 9.84129C11.9024 10.3638 11.2609 10.625 10.5002 10.625ZM10.5002 17.9167C9.40086 17.9167 8.36961 17.71 7.40641 17.2965C6.44322 16.883 5.60537 16.32 4.89287 15.6073C4.18023 14.8948 3.61718 14.057 3.2037 13.0938C2.79023 12.1306 2.5835 11.0993 2.5835 10C2.5835 8.90073 2.79023 7.86948 3.2037 6.90629C3.61718 5.9431 4.18023 5.10525 4.89287 4.39275C5.60537 3.68011 6.44322 3.11705 7.40641 2.70358C8.36961 2.29011 9.40086 2.08337 10.5002 2.08337C11.5995 2.08337 12.6307 2.29011 13.5939 2.70358C14.5571 3.11705 15.395 3.68011 16.1075 4.39275C16.8201 5.10525 17.3831 5.9431 17.7966 6.90629C18.2101 7.86948 18.4168 8.90073 18.4168 10C18.4168 11.0993 18.2101 12.1306 17.7966 13.0938C17.3831 14.057 16.8201 14.8948 16.1075 15.6073C15.395 16.32 14.5571 16.883 13.5939 17.2965C12.6307 17.71 11.5995 17.9167 10.5002 17.9167Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================EmployeeIcon======================================================================///
export const EmployeeIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2525"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2525)">
        <path
          d="M10.5 10.6252C11.2521 10.6252 11.8915 10.3619 12.4183 9.83523C12.945 9.30843 13.2083 8.66898 13.2083 7.9169C13.2083 7.16482 12.945 6.52537 12.4183 5.99857C11.8915 5.4719 11.2521 5.20857 10.5 5.20857C9.74792 5.20857 9.10847 5.4719 8.58167 5.99857C8.055 6.52537 7.79167 7.16482 7.79167 7.9169C7.79167 8.66898 8.055 9.30843 8.58167 9.83523C9.10847 10.3619 9.74792 10.6252 10.5 10.6252ZM10.5 16.5836C11.2821 16.3304 11.9824 15.9425 12.601 15.42C13.2195 14.8977 13.7569 14.2984 14.2131 13.6221C13.6373 13.3272 13.0372 13.1013 12.4127 12.9442C11.7883 12.7871 11.1507 12.7086 10.5 12.7086C9.84931 12.7086 9.21174 12.7871 8.58729 12.9442C7.96285 13.1013 7.36271 13.3272 6.78687 13.6221C7.24312 14.2984 7.78049 14.8977 8.39896 15.42C9.01757 15.9425 9.71792 16.3304 10.5 16.5836ZM10.5 17.8094C10.4135 17.8094 10.3285 17.8025 10.2452 17.7886C10.1619 17.7747 10.0812 17.7538 10.0031 17.7261C8.24576 17.1011 6.84757 15.9929 5.80854 14.4017C4.76951 12.8103 4.25 11.0932 4.25 9.25023V5.49711C4.25 5.18183 4.34139 4.89739 4.52417 4.64378C4.70681 4.39003 4.94181 4.206 5.22917 4.09169L9.97271 2.32086C10.1512 2.25669 10.3269 2.22461 10.5 2.22461C10.6731 2.22461 10.8488 2.25669 11.0273 2.32086L15.7708 4.09169C16.0582 4.206 16.2932 4.39003 16.4758 4.64378C16.6586 4.89739 16.75 5.18183 16.75 5.49711V9.25023C16.75 11.0932 16.2305 12.8103 15.1915 14.4017C14.1524 15.9929 12.7542 17.1011 10.9969 17.7261C10.9188 17.7538 10.8381 17.7747 10.7548 17.7886C10.6715 17.8025 10.5865 17.8094 10.5 17.8094Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================LMSIcon======================================================================///
export const LMSIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2542"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2542)">
        <path
          d="M3.41675 14.2596V8.24518C3.41675 7.89685 3.54522 7.60601 3.80216 7.37268C4.05911 7.13921 4.36175 7.03636 4.71008 7.06414C5.79661 7.2308 6.82835 7.55372 7.80529 8.03289C8.78237 8.51205 9.68064 9.12289 10.5001 9.86539C11.3195 9.12289 12.2178 8.51205 13.1949 8.03289C14.1718 7.55372 15.2036 7.2308 16.2901 7.06414C16.6384 7.03636 16.9411 7.13921 17.198 7.37268C17.4549 7.60601 17.5834 7.89685 17.5834 8.24518V14.2596C17.5834 14.5918 17.4736 14.8768 17.254 15.1146C17.0345 15.3522 16.7586 15.4849 16.4263 15.5127C15.4947 15.657 14.6108 15.8875 13.7749 16.2043C12.9389 16.521 12.1384 16.9486 11.3734 17.4871C11.242 17.5907 11.1042 17.6671 10.9601 17.7162C10.8158 17.7654 10.6624 17.79 10.5001 17.79C10.3377 17.79 10.1844 17.7654 10.0401 17.7162C9.89592 17.6671 9.75814 17.5907 9.62675 17.4871C8.86175 16.9486 8.06258 16.521 7.22925 16.2043C6.39592 15.8875 5.51078 15.657 4.57383 15.5127C4.24161 15.4849 3.96571 15.3522 3.74612 15.1146C3.52654 14.8768 3.41675 14.5918 3.41675 14.2596ZM10.5001 7.32372C9.66883 7.32372 8.9589 7.02935 8.37029 6.4406C7.78168 5.85199 7.48737 5.14205 7.48737 4.3108C7.48737 3.47969 7.78168 2.76976 8.37029 2.18101C8.9589 1.5924 9.66883 1.2981 10.5001 1.2981C11.3313 1.2981 12.0413 1.5924 12.6299 2.18101C13.2185 2.76976 13.5128 3.47969 13.5128 4.3108C13.5128 5.14205 13.2185 5.85199 12.6299 6.4406C12.0413 7.02935 11.3313 7.32372 10.5001 7.32372Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================AttendanceIcon======================================================================///
export const AttendanceIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2533"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2533)">
        <path
          d="M4.92321 17.9167C4.50223 17.9167 4.14591 17.7708 3.85425 17.4792C3.56258 17.1875 3.41675 16.8312 3.41675 16.4102V5.25647C3.41675 4.8355 3.56258 4.47918 3.85425 4.18751C4.14591 3.89585 4.50223 3.75001 4.92321 3.75001H6.07696V2.62814C6.07696 2.4455 6.13814 2.293 6.2605 2.17064C6.38286 2.04842 6.53536 1.9873 6.718 1.9873C6.90078 1.9873 7.05328 2.04842 7.1755 2.17064C7.29786 2.293 7.35904 2.4455 7.35904 2.62814V3.75001H13.6732V2.6123C13.6732 2.43494 13.733 2.2864 13.8526 2.16668C13.9723 2.0471 14.1208 1.9873 14.2982 1.9873C14.4756 1.9873 14.624 2.0471 14.7436 2.16668C14.8633 2.2864 14.9232 2.43494 14.9232 2.6123V3.75001H16.077C16.4979 3.75001 16.8542 3.89585 17.1459 4.18751C17.4376 4.47918 17.5834 4.8355 17.5834 5.25647V16.4102C17.5834 16.8312 17.4376 17.1875 17.1459 17.4792C16.8542 17.7708 16.4979 17.9167 16.077 17.9167H4.92321ZM4.92321 16.6667H16.077C16.1411 16.6667 16.1999 16.6399 16.2532 16.5865C16.3067 16.5331 16.3334 16.4744 16.3334 16.4102V8.5898H4.66675V16.4102C4.66675 16.4744 4.69348 16.5331 4.74696 16.5865C4.80029 16.6399 4.85904 16.6667 4.92321 16.6667ZM10.5001 11.7308C10.2961 11.7308 10.1222 11.659 9.97842 11.5152C9.8348 11.3716 9.763 11.1977 9.763 10.9936C9.763 10.7895 9.8348 10.6156 9.97842 10.4719C10.1222 10.3283 10.2961 10.2565 10.5001 10.2565C10.7041 10.2565 10.878 10.3283 11.0217 10.4719C11.1654 10.6156 11.2372 10.7895 11.2372 10.9936C11.2372 11.1977 11.1654 11.3716 11.0217 11.5152C10.878 11.659 10.7041 11.7308 10.5001 11.7308ZM7.16675 11.7308C6.96272 11.7308 6.78883 11.659 6.64508 11.5152C6.50147 11.3716 6.42966 11.1977 6.42966 10.9936C6.42966 10.7895 6.50147 10.6156 6.64508 10.4719C6.78883 10.3283 6.96272 10.2565 7.16675 10.2565C7.37078 10.2565 7.54467 10.3283 7.68842 10.4719C7.83203 10.6156 7.90383 10.7895 7.90383 10.9936C7.90383 11.1977 7.83203 11.3716 7.68842 11.5152C7.54467 11.659 7.37078 11.7308 7.16675 11.7308ZM13.8334 11.7308C13.6294 11.7308 13.4555 11.659 13.3117 11.5152C13.1681 11.3716 13.0963 11.1977 13.0963 10.9936C13.0963 10.7895 13.1681 10.6156 13.3117 10.4719C13.4555 10.3283 13.6294 10.2565 13.8334 10.2565C14.0374 10.2565 14.2113 10.3283 14.3551 10.4719C14.4987 10.6156 14.5705 10.7895 14.5705 10.9936C14.5705 11.1977 14.4987 11.3716 14.3551 11.5152C14.2113 11.659 14.0374 11.7308 13.8334 11.7308ZM10.5001 15C10.2961 15 10.1222 14.9281 9.97842 14.7844C9.8348 14.6408 9.763 14.467 9.763 14.2629C9.763 14.0588 9.8348 13.8849 9.97842 13.7413C10.1222 13.5975 10.2961 13.5256 10.5001 13.5256C10.7041 13.5256 10.878 13.5975 11.0217 13.7413C11.1654 13.8849 11.2372 14.0588 11.2372 14.2629C11.2372 14.467 11.1654 14.6408 11.0217 14.7844C10.878 14.9281 10.7041 15 10.5001 15ZM7.16675 15C6.96272 15 6.78883 14.9281 6.64508 14.7844C6.50147 14.6408 6.42966 14.467 6.42966 14.2629C6.42966 14.0588 6.50147 13.8849 6.64508 13.7413C6.78883 13.5975 6.96272 13.5256 7.16675 13.5256C7.37078 13.5256 7.54467 13.5975 7.68842 13.7413C7.83203 13.8849 7.90383 14.0588 7.90383 14.2629C7.90383 14.467 7.83203 14.6408 7.68842 14.7844C7.54467 14.9281 7.37078 15 7.16675 15ZM13.8334 15C13.6294 15 13.4555 14.9281 13.3117 14.7844C13.1681 14.6408 13.0963 14.467 13.0963 14.2629C13.0963 14.0588 13.1681 13.8849 13.3117 13.7413C13.4555 13.5975 13.6294 13.5256 13.8334 13.5256C14.0374 13.5256 14.2113 13.5975 14.3551 13.7413C14.4987 13.8849 14.5705 14.0588 14.5705 14.2629C14.5705 14.467 14.4987 14.6408 14.3551 14.7844C14.2113 14.9281 14.0374 15 13.8334 15Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================ReportsIcon======================================================================///
export const ReportsIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2584"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2584)">
        <path
          d="M4.92321 17.0833C4.5089 17.0833 4.15425 16.9358 3.85925 16.6408C3.56425 16.3458 3.41675 15.9912 3.41675 15.5769V4.42313C3.41675 4.00882 3.56425 3.65417 3.85925 3.35917C4.15425 3.06417 4.5089 2.91667 4.92321 2.91667H8.63154C8.6839 2.45403 8.88585 2.06062 9.23737 1.73646C9.58876 1.41215 10.011 1.25 10.504 1.25C10.9971 1.25 11.4194 1.41215 11.7709 1.73646C12.1224 2.06062 12.3217 2.45403 12.3686 2.91667H16.077C16.4913 2.91667 16.8459 3.06417 17.1409 3.35917C17.4359 3.65417 17.5834 4.00882 17.5834 4.42313V15.5769C17.5834 15.9912 17.4359 16.3458 17.1409 16.6408C16.8459 16.9358 16.4913 17.0833 16.077 17.0833H4.92321ZM7.16675 13.8621H11.3334C11.5105 13.8621 11.6589 13.8022 11.7786 13.6823C11.8985 13.5626 11.9584 13.4141 11.9584 13.2369C11.9584 13.0598 11.8985 12.9114 11.7786 12.7917C11.6589 12.6721 11.5105 12.6123 11.3334 12.6123H7.16675C6.98966 12.6123 6.84126 12.6722 6.72154 12.7919C6.60168 12.9117 6.54175 13.0603 6.54175 13.2375C6.54175 13.4146 6.60168 13.563 6.72154 13.6827C6.84126 13.8023 6.98966 13.8621 7.16675 13.8621ZM7.16675 10.625H13.8334C14.0105 10.625 14.1589 10.5651 14.2786 10.4452C14.3985 10.3253 14.4584 10.1769 14.4584 9.99979C14.4584 9.82257 14.3985 9.67417 14.2786 9.55458C14.1589 9.43486 14.0105 9.375 13.8334 9.375H7.16675C6.98966 9.375 6.84126 9.43493 6.72154 9.55479C6.60168 9.67465 6.54175 9.82313 6.54175 10.0002C6.54175 10.1774 6.60168 10.3258 6.72154 10.4454C6.84126 10.5651 6.98966 10.625 7.16675 10.625ZM7.16675 7.38771H13.8334C14.0105 7.38771 14.1589 7.32785 14.2786 7.20812C14.3985 7.08826 14.4584 6.93972 14.4584 6.7625C14.4584 6.58542 14.3985 6.43701 14.2786 6.31729C14.1589 6.19771 14.0105 6.13792 13.8334 6.13792H7.16675C6.98966 6.13792 6.84126 6.19785 6.72154 6.31771C6.60168 6.43743 6.54175 6.5859 6.54175 6.76312C6.54175 6.94021 6.60168 7.08861 6.72154 7.20833C6.84126 7.32792 6.98966 7.38771 7.16675 7.38771ZM10.5001 3.62187C10.6806 3.62187 10.8299 3.56285 10.948 3.44479C11.0661 3.32674 11.1251 3.17743 11.1251 2.99687C11.1251 2.81632 11.0661 2.66701 10.948 2.54896C10.8299 2.4309 10.6806 2.37187 10.5001 2.37187C10.3195 2.37187 10.1702 2.4309 10.0522 2.54896C9.93411 2.66701 9.87508 2.81632 9.87508 2.99687C9.87508 3.17743 9.93411 3.32674 10.0522 3.44479C10.1702 3.56285 10.3195 3.62187 10.5001 3.62187Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================FinanceIcon======================================================================///
export const FinanceIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2576"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2576)">
        <path
          d="M4.92321 17.0834C4.50223 17.0834 4.14591 16.9376 3.85425 16.6459C3.56258 16.3542 3.41675 15.9979 3.41675 15.577V4.42321C3.41675 4.00223 3.56258 3.64591 3.85425 3.35425C4.14591 3.06258 4.50223 2.91675 4.92321 2.91675H16.077C16.4979 2.91675 16.8542 3.06258 17.1459 3.35425C17.4376 3.64591 17.5834 4.00223 17.5834 4.42321V5.00008H11.5899C10.764 5.00008 10.0982 5.25307 9.59237 5.75904C9.0864 6.26487 8.83341 6.93071 8.83341 7.75654V12.2436C8.83341 13.0695 9.0864 13.7353 9.59237 14.2411C10.0982 14.7471 10.764 15.0001 11.5899 15.0001H17.5834V15.577C17.5834 15.9979 17.4376 16.3542 17.1459 16.6459C16.8542 16.9376 16.4979 17.0834 16.077 17.0834H4.92321ZM11.5899 13.7501C11.1689 13.7501 10.8126 13.6042 10.5209 13.3126C10.2292 13.0209 10.0834 12.6646 10.0834 12.2436V7.75654C10.0834 7.33557 10.2292 6.97925 10.5209 6.68758C10.8126 6.39592 11.1689 6.25008 11.5899 6.25008H16.9103C17.3313 6.25008 17.6876 6.39592 17.9792 6.68758C18.2709 6.97925 18.4167 7.33557 18.4167 7.75654V12.2436C18.4167 12.6646 18.2709 13.0209 17.9792 13.3126C17.6876 13.6042 17.3313 13.7501 16.9103 13.7501H11.5899ZM13.8334 11.2501C14.1945 11.2501 14.4931 11.132 14.7292 10.8959C14.9654 10.6598 15.0834 10.3612 15.0834 10.0001C15.0834 9.63897 14.9654 9.34036 14.7292 9.10425C14.4931 8.86814 14.1945 8.75008 13.8334 8.75008C13.4723 8.75008 13.1737 8.86814 12.9376 9.10425C12.7015 9.34036 12.5834 9.63897 12.5834 10.0001C12.5834 10.3612 12.7015 10.6598 12.9376 10.8959C13.1737 11.132 13.4723 11.2501 13.8334 11.2501Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
export const SettingsIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_128_2592"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_128_2592)">
        <path
          d="M9.57736 17.9166C9.29319 17.9166 9.04777 17.8223 8.84111 17.6337C8.6343 17.4452 8.50847 17.2131 8.46361 16.9374L8.26007 15.378C8.03687 15.3033 7.80798 15.1987 7.5734 15.0641C7.33896 14.9294 7.1293 14.7851 6.94444 14.6314L5.50048 15.2451C5.23868 15.3605 4.97562 15.3717 4.71132 15.2787C4.44687 15.1858 4.24146 15.017 4.09507 14.7724L3.1559 13.1441C3.00951 12.8995 2.96736 12.6407 3.02944 12.3676C3.09139 12.0947 3.23347 11.8696 3.45569 11.6922L4.70403 10.7547C4.68486 10.6308 4.67125 10.5064 4.66319 10.3814C4.65514 10.2564 4.65111 10.1319 4.65111 10.0078C4.65111 9.88936 4.65514 9.76895 4.66319 9.64659C4.67125 9.52422 4.68486 9.39041 4.70403 9.24513L3.45569 8.30763C3.23347 8.13027 3.09271 7.90374 3.0334 7.62804C2.97409 7.35249 3.01764 7.09235 3.16403 6.84763L4.09507 5.24346C4.24146 5.00415 4.44687 4.83672 4.71132 4.74117C4.97562 4.64547 5.23868 4.65534 5.50048 4.77075L6.93632 5.37659C7.13729 5.21742 7.3518 5.07186 7.57986 4.93992C7.80791 4.80797 8.03201 4.70193 8.25215 4.62179L8.46361 3.06242C8.50847 2.78672 8.6343 2.55464 8.84111 2.36617C9.04777 2.17756 9.29319 2.08325 9.57736 2.08325H11.4236C11.7078 2.08325 11.9532 2.17756 12.1599 2.36617C12.3667 2.55464 12.4925 2.78672 12.5374 3.06242L12.7409 4.62971C12.9909 4.72054 13.2171 4.82659 13.4194 4.94784C13.6219 5.06909 13.8263 5.212 14.0326 5.37659L15.5086 4.77075C15.7703 4.65534 16.0333 4.64547 16.2978 4.74117C16.5622 4.83672 16.7676 5.00415 16.9138 5.24346L17.8451 6.85575C17.9915 7.10034 18.0336 7.35915 17.9715 7.63221C17.9096 7.90513 17.7675 8.13027 17.5453 8.30763L16.2649 9.26909C16.2947 9.40367 16.311 9.5295 16.3138 9.64659C16.3165 9.76353 16.3178 9.88131 16.3178 9.99992C16.3178 10.1131 16.3151 10.2283 16.3097 10.3453C16.3044 10.4623 16.2852 10.5961 16.2522 10.7468L17.5084 11.6922C17.7306 11.8696 17.8741 12.0947 17.9388 12.3676C18.0034 12.6407 17.9625 12.8995 17.8161 13.1441L16.8721 14.7643C16.7259 15.009 16.5192 15.1778 16.2522 15.2708C15.9851 15.3637 15.7206 15.3524 15.4588 15.237L14.0326 14.6233C13.8263 14.7878 13.6158 14.9334 13.4011 15.0599C13.1864 15.1866 12.9663 15.29 12.7409 15.3701L12.5374 16.9374C12.4925 17.2131 12.3667 17.4452 12.1599 17.6337C11.9532 17.8223 11.7078 17.9166 11.4236 17.9166H9.57736ZM10.5101 12.4999C11.2034 12.4999 11.7934 12.2566 12.2801 11.7699C12.7667 11.2833 13.0101 10.6933 13.0101 9.99992C13.0101 9.30659 12.7667 8.71658 12.2801 8.22992C11.7934 7.74325 11.2034 7.49992 10.5101 7.49992C9.80812 7.49992 9.21597 7.74325 8.73361 8.22992C8.25125 8.71658 8.01007 9.30659 8.01007 9.99992C8.01007 10.6933 8.25125 11.2833 8.73361 11.7699C9.21597 12.2566 9.80812 12.4999 10.5101 12.4999Z"
          fill="currentcolor"
        />
      </g>
    </svg>
  );
};
// =============================================================PhoneIcon======================================================================///
export const PhoneIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
      width="21"
      height="20"

    >
      <path fill="currentcolor" d="M21.384,17.752a2.108,2.108,0,0,1-.522,3.359,7.543,7.543,0,0,1-5.476.642C10.5,20.523,3.477,13.5,2.247,8.614a7.543,7.543,0,0,1,.642-5.476,2.108,2.108,0,0,1,3.359-.522L8.333,4.7a2.094,2.094,0,0,1,.445,2.328A3.877,3.877,0,0,1,8,8.2c-2.384,2.384,5.417,10.185,7.8,7.8a3.877,3.877,0,0,1,1.173-.781,2.092,2.092,0,0,1,2.328.445Z" />
    </svg>
  )
}
// =============================================================NotificationIcon======================================================================///
export const NotificationIcon = () => {
  return(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_17_188" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_17_188)">
      <path fill="currentcolor" d="M3.33333 15.8333V14.1667H4.99999V8.33332C4.99999 7.18055 5.34722 6.15624 6.04166 5.26041C6.73611 4.36457 7.63888 3.77777 8.74999 3.49999V2.91666C8.74999 2.56943 8.87152 2.2743 9.11458 2.03124C9.35763 1.78818 9.65277 1.66666 9.99999 1.66666C10.3472 1.66666 10.6424 1.78818 10.8854 2.03124C11.1285 2.2743 11.25 2.56943 11.25 2.91666V3.49999C12.3611 3.77777 13.2639 4.36457 13.9583 5.26041C14.6528 6.15624 15 7.18055 15 8.33332V14.1667H16.6667V15.8333H3.33333ZM9.99999 18.3333C9.54166 18.3333 9.1493 18.1701 8.82291 17.8437C8.49652 17.5174 8.33333 17.125 8.33333 16.6667H11.6667C11.6667 17.125 11.5035 17.5174 11.1771 17.8437C10.8507 18.1701 10.4583 18.3333 9.99999 18.3333Z"  />
    </g>
  </svg>
  )
}

export const AnalyticsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M3 17H5V21H3V17ZM7 13H9V21H7V13ZM11 9H13V21H11V9ZM15 5H17V21H15V5ZM19 1H21V21H19V1Z"
      />
    </svg>
  );
};

export const LmsIcon = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M9 6c0-1.65685 1.3431-3 3-3s3 1.34315 3 3-1.3431 3-3 3-3-1.34315-3-3Zm2 3.62992c-.1263-.04413-.25-.08799-.3721-.13131-1.33928-.47482-2.49256-.88372-4.77995-.8482C4.84875 8.66593 4 9.46413 4 10.5v7.2884c0 1.0878.91948 1.8747 1.92888 1.8616 1.283-.0168 2.04625.1322 2.79671.3587.29285.0883.57733.1863.90372.2987l.00249.0008c.11983.0413.24534.0845.379.1299.2989.1015.6242.2088.9892.3185V9.62992Zm2-.00374V20.7551c.5531-.1678 1.0379-.3374 1.4545-.4832.2956-.1034.5575-.1951.7846-.2653.7257-.2245 1.4655-.3734 2.7479-.3566.5019.0065.9806-.1791 1.3407-.4788.3618-.3011.6723-.781.6723-1.3828V10.5c0-.58114-.2923-1.05022-.6377-1.3503-.3441-.29904-.8047-.49168-1.2944-.49929-2.2667-.0352-3.386.36906-4.6847.83812-.1256.04539-.253.09138-.3832.13765Z" />
    </svg>
  );
};

export const AssesmentCategories = () => {
  return (
<svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
>
<path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023"
      />
</svg>
  );
}

  export const CompanyIcon = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 7H5a2 2 0 0 0-2 2v4m5-6h8M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m0 0h3a2 2 0 0 1 2 2v4m0 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6m18 0s-4 2-9 2-9-2-9-2m9-2h.01"
      />
    </svg>
  );
};



export const Reason=()=>{
  return(
    <svg
    className="w-6 h-6 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 5V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5M9 3v4a1 1 0 0 1-1 1H4m11.383.772 2.745 2.746m1.215-3.906a2.089 2.089 0 0 1 0 2.953l-6.65 6.646L9 17.95l.739-3.692 6.646-6.646a2.087 2.087 0 0 1 2.958 0Z"
    />
  </svg>
  );
}

export const ShiftListIcon = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z"
      />
    </svg>
  );
};

export const SubjectTypeIcon = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 19V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v13H7a2 2 0 0 0-2 2Zm0 0a2 2 0 0 0 2 2h12M9 3v14m7 0v4"
      />
    </svg>
  );
};

export const FacultyType = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      />
    </svg>
  );
};


export const FacultyMapWithDepartment = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14.7141 15h4.268c.4043 0 .732-.3838.732-.8571V3.85714c0-.47338-.3277-.85714-.732-.85714H6.71411c-.55228 0-1 .44772-1 1v4m10.99999 7v-3h3v3h-3Zm-3 6H6.71411c-.55228 0-1-.4477-1-1 0-1.6569 1.34315-3 3-3h2.99999c1.6569 0 3 1.3431 3 3 0 .5523-.4477 1-1 1Zm-1-9.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.49999-1.1193-2.49999-2.5S8.8334 9 10.2141 9s2.5 1.1193 2.5 2.5Z"
      />
    </svg>
  );
};

export const ExamInstructionTemplate = () => {
  return (
    <svg
      className="w-6 h-6 text-gray-800 dark:text-white"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m4.988 19.012 5.41-5.41m2.366-6.424 4.058 4.058-2.03 5.41L5.3 20 4 18.701l3.355-9.494 5.41-2.029Zm4.626 4.625L12.197 6.61 14.807 4 20 9.194l-2.61 2.61Z"
      />
    </svg>
  );
};